import { RectDataPoint } from '../../../types/data-point.js';
import { Line } from '../../../types/line.js';
import { HALF_PIXEL_CORRECTION, OVERLAY_PADDING } from '../constants.js';

export type RectLimits = {
  drawableTop: boolean;
  drawableRight: boolean;
  drawableBottom: boolean;
  drawableLeft: boolean;
};

/**
 * Returns the perimeter lines of a rectangle, omitting lines that touch chart edges with axes.
 */
export const getRectPerimeterLines = (
  point: RectDataPoint,
  chartWidth: number,
  chartHeight: number,
  limitations: RectLimits,
): Line[] => {
  const touchingTop = point.y <= OVERLAY_PADDING + HALF_PIXEL_CORRECTION;
  const touchingRight =
    point.x + point.width >= chartWidth + HALF_PIXEL_CORRECTION;
  const touchingBottom =
    point.y + point.height >= chartHeight + HALF_PIXEL_CORRECTION;
  const touchingLeft = point.x <= OVERLAY_PADDING + HALF_PIXEL_CORRECTION;

  const drawTop = !(touchingTop && limitations.drawableTop);
  const drawRight = !(touchingRight && limitations.drawableRight);
  const drawBottom = !(touchingBottom && limitations.drawableBottom);
  const drawLeft = !(touchingLeft && limitations.drawableLeft);

  const x0 = Math.max(point.x, OVERLAY_PADDING) + HALF_PIXEL_CORRECTION;
  const y0 = point.y + HALF_PIXEL_CORRECTION;

  const maxX = chartWidth + OVERLAY_PADDING - HALF_PIXEL_CORRECTION;
  const rawX1 = point.x + point.width;
  const x1 =
    Math.min(rawX1, maxX) -
    (touchingRight && rawX1 <= maxX ? HALF_PIXEL_CORRECTION : 0);
  const y1 = point.y + point.height;

  const linesToDraw: Line[] = [];
  if (drawTop) {
    linesToDraw.push({ start: { x: x0, y: y0 }, end: { x: x1, y: y0 } });
  }
  if (drawRight) {
    linesToDraw.push({ start: { x: x1, y: y0 }, end: { x: x1, y: y1 } });
  }
  if (drawBottom) {
    linesToDraw.push({ start: { x: x1, y: y1 }, end: { x: x0, y: y1 } });
  }
  if (drawLeft) {
    linesToDraw.push({ start: { x: x0, y: y1 }, end: { x: x0, y: y0 } });
  }
  return linesToDraw;
};
